export const ADMIN_BASE_PATH = "/cp-44d1406aad2c685f49a0e0ef";

export function adminPath(section = "") {
  return `${ADMIN_BASE_PATH}${section}`;
}

export function isAdminPath(path: string) {
  return path === ADMIN_BASE_PATH || path.startsWith(`${ADMIN_BASE_PATH}/`);
}